import type { Table as ITable } from '@tanstack/react-table';

import { TableCell, TableRow } from '@cobliteam/ui/components/Table';
import { cn } from '@cobliteam/ui/utils';

interface DataTableSelectActionsProps<TData> {
  columnsDef: any;
  table: ITable<TData>;
  children: any;
  totalRows?: number;
  className?: string;
}

const DataTableSelectActions = <TData,>({ columnsDef, table, children, className }: DataTableSelectActionsProps<TData>) => {
  return (
    <TableRow className={cn('fade-in animate-in bg-primary-a4', className)}>
      {Object.keys(table.getState().rowSelection).length ? (
        <TableCell colSpan={columnsDef.length} className='fade-in slide-in-from-top-2 h-14 w-full animate-in transition-all duration-1000'>
          {children}
        </TableCell>
      ) : null}
    </TableRow>
  );
};

export default DataTableSelectActions;
